document.addEventListener('DOMContentLoaded', () => {
  if (document.documentElement.dataset.productFaqInitialized === 'true') return;
  document.documentElement.dataset.productFaqInitialized = 'true';

  const TRANSITION_DURATION = 300;
  const pendingTimeouts = new WeakMap();

  const clearPendingTimeout = (item) => {
    const timeoutId = pendingTimeouts.get(item);
    if (timeoutId) {
      clearTimeout(timeoutId);
      pendingTimeouts.delete(item);
    }
  };

  const closeItem = (item) => {
    const answer = item.querySelector('.product-faq__answer');
    const button = item.querySelector('.product-faq__question');

    clearPendingTimeout(item);

    const currentHeight = answer.scrollHeight;
    answer.style.height = `${currentHeight}px`;
    answer.offsetHeight;

    item.classList.remove('product-faq__item--open');
    answer.style.height = '0px';
    button.setAttribute('aria-expanded', 'false');

    pendingTimeouts.set(item, setTimeout(() => {
      answer.setAttribute('hidden', '');
      pendingTimeouts.delete(item);
    }, TRANSITION_DURATION));
  };

  const openItem = (item) => {
    const answer = item.querySelector('.product-faq__answer');
    const button = item.querySelector('.product-faq__question');

    clearPendingTimeout(item);

    answer.removeAttribute('hidden');
    answer.style.height = '0px';
    answer.offsetHeight;

    item.classList.add('product-faq__item--open');
    answer.style.height = `${answer.scrollHeight}px`;
    button.setAttribute('aria-expanded', 'true');

    pendingTimeouts.set(item, setTimeout(() => {
      answer.style.height = 'auto';
      pendingTimeouts.delete(item);
    }, TRANSITION_DURATION));
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.product-faq__question');
    if (!button) return;

    const item = button.closest('.product-faq__item');
    const section = button.closest('.product-faq');
    if (!item || !section) return;

    const allowMultipleOpen = section.dataset.allowMultipleOpen === 'true';
    const isOpen = item.classList.contains('product-faq__item--open');

    if (!allowMultipleOpen) {
      section.querySelectorAll('.product-faq__item--open').forEach((otherItem) => {
        if (otherItem !== item) closeItem(otherItem);
      });
    }

    if (isOpen) {
      closeItem(item);
    } else {
      openItem(item);
    }
  });
});
